import { useAuthStore } from "@/stores";
import axios from "axios";
import { setup } from "axios-cache-adapter";
import { attachUnauthorizedInterceptor } from "./handleUnauthorized";
import { getBearerToken } from "./getBearerToken";

export function http() {
  const authStore = useAuthStore();
  const instance = axios.create({
    baseURL: "/api",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  instance.interceptors.request.use((config) => {
    const token = getBearerToken(authStore.$state.token);

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  attachUnauthorizedInterceptor(instance);

  return instance;
}
let cachedInstance; // keep one instance across calls

export function httpWithCache(maxAge = 1000 * 60 * 3) {
  if (cachedInstance) return cachedInstance;

  const authStore = useAuthStore();

  cachedInstance = setup({
    baseURL: "/api",
    cache: {
      maxAge,
      exclude: { query: false },
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  cachedInstance.interceptors.request.use((config) => {
    const token = getBearerToken(authStore.$state.token);

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  attachUnauthorizedInterceptor(cachedInstance);

  return cachedInstance;
}
